var map = {
	"./actions/ordini": [
		270
	],
	"./actions/ordini.js": [
		270
	],
	"./apis/ordini": [
		436
	],
	"./apis/ordini.js": [
		436
	],
	"./components/OrdiniEdit": [
		1213,
		325
	],
	"./components/OrdiniEdit.js": [
		1213,
		325
	],
	"./components/OrdiniListFilter": [
		1375,
		4,
		43
	],
	"./components/OrdiniListFilter.js": [
		1375,
		4,
		43
	],
	"./components/OrdiniListFooter": [
		1214,
		326
	],
	"./components/OrdiniListFooter.js": [
		1214,
		326
	],
	"./components/OrdiniListTable": [
		1215,
		319
	],
	"./components/OrdiniListTable.js": [
		1215,
		319
	],
	"./components/SummaryFooter": [
		1216,
		320
	],
	"./components/SummaryFooter.js": [
		1216,
		320
	],
	"./components/SummaryTable": [
		1217,
		321
	],
	"./components/SummaryTable.js": [
		1217,
		321
	],
	"./containers/OrdiniListLayout": [
		1458,
		4,
		14,
		43,
		322
	],
	"./containers/OrdiniListLayout.js": [
		1458,
		4,
		14,
		43,
		322
	],
	"./containers/OrdiniLoader": [
		1459,
		323
	],
	"./containers/OrdiniLoader.js": [
		1459,
		323
	],
	"./helpers": [
		1028,
		324
	],
	"./helpers.js": [
		1028,
		324
	],
	"./reducers/ordini": [
		165
	],
	"./reducers/ordini.js": [
		165
	],
	"./routes/ordini": [
		521
	],
	"./routes/ordini.js": [
		521
	],
	"./sagas/ordini": [
		604
	],
	"./sagas/ordini.js": [
		604
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2045;
module.exports = webpackAsyncContext;